export default class TimelineModel {
    id: number | null;
    titulo: string | null;
    descricao: string | null;
    imagem_Url: string | null;
    imagem_Thumbnail_Url: string | null;
    createdAt: string | null;
    updatedAt: string | null;
    publishedAt: string | null;

    constructor(
        id: number | null,
        titulo: string | null,
        descricao: string | null,
        imagem_Url: string | null,
        imagem_Thumbnail_Url: string | null,
        createdAt: string | null,
        updatedAt: string | null,
        publishedAt: string | null
    ) {
        this.id = id;
        this.titulo = titulo;
        this.descricao = descricao;
        this.imagem_Url = imagem_Url;
        this.imagem_Thumbnail_Url = imagem_Thumbnail_Url;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.publishedAt = publishedAt;
    }

    static fromApiResponse(data: any): TimelineModel {
        return new TimelineModel(
            data.id || null,
            data.attributes.titulo || null,
            data.attributes.descricao || null,
            data.attributes.imagem?.data?.attributes?.url || null,
            data.attributes.imagem?.data?.attributes?.formats?.thumbnail?.url || null,
            data.attributes.createdAt || null,
            data.attributes.updatedAt || null,
            data.attributes.publishedAt || null
        );
    }
}
